<app-loader loaderId="pageLoader" size="large"></app-loader>
<div class="flex flex-col lg:flex-row w-full h-screen">
    <!-- Image Section - Larger on Desktop -->
    <div class="relative lg:flex-[1.8] bg-cover bg-center flex flex-col justify-end p-8 sm:p-12 md:p-14 lg:p-16 xl:p-20 min-h-[40vh] lg:min-h-screen"
        style="background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('./login-bg.png')">
        <div class="absolute inset-0 gradient-overlay"></div>
        <div class="relative z-10 max-w-2xl mx-auto lg:mx-0 text-center lg:text-left">
            <h1
                class="text-2xl sm:text-2xl md:text-4xl lg:text-5xl xl:text-6xl font-extrabold mb-1 sm:mb-2 lg:mb-3 text-white drop-shadow-lg leading-tight">
                Elan Glam Premium
            </h1>
            <p
                class="text-md sm:text-lg lg:text-2xl xl:text-3xl opacity-90 mb-6 sm:mb-8 lg:mb-12 font-light text-white">
                Family Salon & Luxury Beauty Experience
            </p>
        </div>
    </div>

    <!-- Login Section - Smaller on Desktop -->
    <div
        class="lg:flex-[0.8] bg-bg text-white p-6 sm:p-8 md:p-10 lg:p-12 xl:p-14 flex flex-col justify-center overflow-y-auto min-h-[60vh] lg:min-h-screen">
        <div class="text-center mb-6 sm:mb-8 md:mb-8 lg:mb-8 xl:mb-10">
            <h2 class="text-xl sm:text-2xl md:text-3xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-medium text-white">
                Login Into Account</h2>
            <!-- <p class="text-base sm:text-lg md:text-xl lg:text-lg xl:text-xl text-text-white font-light">Welcome to Elan Glam Premium</p> -->
        </div>

        <form class="w-full max-w-sm lg:max-w-xs xl:max-w-sm mx-auto" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="relative flex items-start w-full login-form-size">
                <div
                    class="relative left-0 top-0 h-[3rem] w-12 rounded-tl-xl rounded-bl-xl text-secondary bg-white flex items-center justify-center">
                    <i class="fa-solid fa-user text-sm sm:text-base md:text-lg"></i>
                </div>
                <app-input-field placeholder="Your username" type="text"
                    [className]="'!h-[3rem] bg-dark-bg border border-dark-border rounded-none rounded-r-xl px-3 py-3 text-white text-base sm:text-lg transition-colors duration-200 focus:border-primary focus:outline-none placeholder-text-white'"
                    [formControl]="getControl('email')" [submit]="submit" [required]="true"
                    (keydown.enter)="onSubmit()"></app-input-field>
            </div>
            <div class="relative flex items-start w-full login-form-size">
                <div
                    class="relative left-0 top-0 h-[3rem] w-12 rounded-tl-xl rounded-bl-xl text-secondary bg-white flex items-center justify-center">
                    <i class="fa-solid fa-lock text-sm sm:text-base md:text-lg"></i>
                </div>
                <app-input-field placeholder="Your password" type="password"
                    [className]="'!h-[3rem] bg-dark-bg border border-dark-border rounded-none rounded-r-xl px-3 py-3 text-white text-base sm:text-lg transition-colors duration-200 focus:border-primary focus:outline-none placeholder-text-white'"
                    [formControl]="getControl('password')" [submit]="submit" [required]="true"
                    (keydown.enter)="onSubmit()"></app-input-field>
            </div>
            <div class="mb-4 sm:mb-5 lg:mb-4 xl:mb-5 flex items-center">
                <app-checkbox label="Remember me"
                    className="w-6 h-6 sm:w-5 sm:h-5 bg-dark-bg border border-text rounded focus:ring-primary focus:ring-2"
                    labelClass="ml-0 text-text-white text-base sm:text-lg lg:text-base xl:text-lg"
                    [formControl]="getControl('rememberMe')"></app-checkbox>
            </div>
            <div class="w-full text-center">
                <app-button className="mt-4 sm:mt-5 w-full" loaderId="loginBtnLoader" type="submit"> Sign
                    In</app-button>
            </div>
        </form>
        <!-- <div class="text-center mt-6 sm:mt-8 lg:mt-6 xl:mt-8 pt-4 sm:pt-6 border-t border-dark-border w-full max-w-sm lg:max-w-xs xl:max-w-sm mx-auto">
                <a href="#" class="text-text-white no-underline transition-all duration-200 font-normal text-base sm:text-lg lg:text-base xl:text-lg hover:text-white hover:underline">
                    Forgot Password?
                </a>
            </div> -->
    </div>
</div>